<template>
  <Button :color="color" :buttonText="buttonText" @click.native.prevent="clearLeaderboard"></Button>
</template>

<script>
import Button from '@/components/Button.vue'

import RecordService from '@/services/RecordService'

export default {
  name: 'admin',
  components: {
    Button
  },
  data() {
    return {
      color: "orange",
      buttonText: "Clear Leaderboard"
    }
  },
  methods: {
    clearLeaderboard: function() {
      RecordService.clearPlayerScores()
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  height: auto;
  left: 50%;
  padding: 25px 35px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto;
}
</style>
